import { EventEmitter, Output, Directive } from "@angular/core";

@Directive()
export abstract class AbstractPopupComponent {
  @Output()
  closed = new EventEmitter();

  public close() {
    this.closed.emit();
  }
}
